import { Link } from 'react-router-dom'

import logo from '../../assets/reilm-logo.svg'

const socialIconProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'currentColor',
  'aria-hidden': true,
}

const InstagramIcon = () => (
  <svg {...socialIconProps}>
    <path d="M4.5 1.5h7a3 3 0 013 3v7a3 3 0 01-3 3h-7a3 3 0 01-3-3v-7a3 3 0 013-3zm3.5 3.5a3 3 0 100 6 3 3 0 000-6zm3.6-.3a.7.7 0 100 1.4.7.7 0 000-1.4z" />
  </svg>
)

const TikTokIcon = () => (
  <svg {...socialIconProps}>
    <path d="M11 1.5h2.2a3.5 3.5 0 002 1.6v2.2a5.7 5.7 0 01-3.2-1V10a4.5 4.5 0 11-4.5-4.5h.5v2.3h-.5a2.2 2.2 0 102.2 2.2V1.5z" />
  </svg>
)

const FacebookIcon = () => (
  <svg {...socialIconProps}>
    <path d="M9.2 14.5V8.6h1.9l.3-2.3H9.2V4.9c0-.7.2-1.1 1.1-1.1h1.2V1.7l-2 -.1c-1.9 0-3 1.1-3 3.1v1.6H4.5v2.3h2.1v5.9z" />
  </svg>
)

const YouTubeIcon = () => (
  <svg {...socialIconProps}>
    <path d="M14.4 4.6a1.9 1.9 0 00-1.3-1.4C12 3 8 3 8 3s-4 0-5.1.2a1.9 1.9 0 00-1.3 1.4A20 20 0 001.4 8a20 20 0 00.2 3.4 1.9 1.9 0 001.3 1.4C4 13 8 13 8 13s4 0 5.1-.2a1.9 1.9 0 001.3-1.4A20 20 0 0014.6 8a20 20 0 00-.2-3.4zM6.6 10V6l3.5 2z" />
  </svg>
)

const ThreadsIcon = () => (
  <svg {...socialIconProps}>
    <path d="M8 1.5C4.5 1.5 1.8 4 1.8 8s2.7 6.5 6.2 6.5c3 0 5-1.8 5.4-4.3.3-1.8-.5-3.4-2.2-4-.2-1.5-1.2-2.4-2.9-2.5-1 0-1.9.4-2.4 1.1l1.1.8c.3-.4.7-.6 1.3-.6.8 0 1.3.5 1.5 1.3-.5-.1-1-.1-1.5 0-1.5.1-2.5 1-2.4 2.3.1 1.2 1.1 2 2.4 2 1.5 0 2.5-1 2.8-2.3.9.5 1.2 1.4 1 2.5-.3 1.6-1.6 2.5-3.5 2.5-2.7 0-4.5-1.9-4.5-4.8s1.7-4.8 4.5-4.8c1.8 0 3.1.9 4 2.5l1.3-.8C12.2 2.7 10.4 1.5 8 1.5zm-.3 6.4c.5 0 1 .1 1.4.2-.2.7-.7 1.2-1.4 1.2-.6 0-1-.3-1-.7 0-.4.4-.7 1-.7z" />
  </svg>
)

const SOCIALS = [
  { label: 'Instagram', Icon: InstagramIcon },
  { label: 'TikTok', Icon: TikTokIcon },
  { label: 'Facebook', Icon: FacebookIcon },
  { label: 'YouTube', Icon: YouTubeIcon },
  { label: 'Threads', Icon: ThreadsIcon },
]

const Footer = () => {
  return (
    <footer className="bg-brand-pageFill">
      <div className="max-w-canvas mx-auto px-[120px] pt-[96px] pb-0 flex justify-between gap-12">
        <div className="flex gap-[132px]">
          <div className="flex flex-col gap-4">
            <p className="text-[20px] leading-[32px] font-bold text-brand-dark tracking-wider">PRODUCT</p>
            <Link
              to="/pricing"
              className="text-[16px] leading-6 text-brand-dark hover:text-brand-green transition-colors"
            >
              Pricing
            </Link>
          </div>

          <div className="flex flex-col gap-4">
            <p className="text-[20px] leading-[32px] font-bold text-brand-dark tracking-wider">LEGAL</p>
            <div className="flex flex-col gap-2 text-[16px] leading-6 text-brand-dark">
              <a href="#" className="hover:text-brand-green transition-colors">
                Terms
              </a>
              <a href="#" className="hover:text-brand-green transition-colors">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>

        <div className="w-[269px] flex flex-col gap-4">
          <div className="flex flex-col gap-2 w-[260px]">
            <img src={logo} alt="reilm" className="w-[109px] h-[32px]" />
            <p className="text-[12px] leading-5 text-brand-dark">
              Real Estate Investments Lucrative Mode
            </p>
          </div>

          <div className="flex items-center gap-[30px]">
            <button
              type="button"
              className="px-6 py-2 rounded-full border border-brand-green text-brand-dark text-[14px] font-semibold leading-6"
            >
              Contact Support
            </button>
            <div className="text-[14px] leading-6 text-brand-dark">
              <p>Monday-Friday</p>
              <p>9:00AM-5:00PM</p>
            </div>
          </div>

          <div className="flex items-center gap-4 mt-2 text-brand-dark">
            {SOCIALS.map(({ label, Icon }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                className="hover:text-brand-green transition-colors"
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-brand-muted mt-[44px]">
        <div className="max-w-canvas mx-auto px-[120px] py-6 flex justify-between">
          <p className="text-[12px] leading-5 text-[#646262]">
            ©2026 REILM, Inc. | All rights reserved
          </p>
          <p className="text-[12px] leading-5 text-[#646262]">
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
